import { render, staticRenderFns } from "./OfferDrawer.vue?vue&type=template&id=38d4389d&"
import script from "./OfferDrawer.vue?vue&type=script&lang=js&"
export * from "./OfferDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports